import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatures, type FeatureRef } from '@/contexts/FeaturesContext';

interface FeatureGateProps {
  feature: FeatureRef;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Renders children only when the given feature flag is enabled.
 * Redirects to dashboard by default when disabled.
 */
export function FeatureGate({ feature, children, fallback }: FeatureGateProps) {
  const { isEnabled, loading } = useFeatures();

  if (loading) return null;

  if (!isEnabled(feature.name)) {
    return fallback ?? <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
